import { Component, OnInit } from '@angular/core';
import { AppFilter } from 'src/modules/shared/';
import { SuiModal, ComponentModalConfig, ModalSize } from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';

interface IViewDetailsContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-view-details-modal',
  templateUrl: './view-details-modal.component.html',
  styleUrls: ['./view-details-modal.component.scss']
})
export class ViewDetailsModalComponent implements OnInit {

  baseUrl = environment.API_SERVER;

  pending: boolean;
  success: any;
  error: any;
  filter: AppFilter = new AppFilter();

  data;

  constructor(
    public modal: SuiModal<IViewDetailsContext, void, void>,
  ) {
    this.data = modal.context.data;
    console.log(this.data, 'extra');
  }

  ngOnInit() {
    if (this.modal.context.title == 'View Topic Details') {

    }
    if (this.modal.context.title == 'View Sub-topic Details') {

    }
  }
  dataToJSON(data: any) {
    try {
      const jsonData = JSON.parse(data);
      return jsonData;
    } catch (error) {
      return null; // or handle the error in another way
    }
  }
}

export class ViewDetailsModal extends ComponentModalConfig<
  IViewDetailsContext,
  void,
  void
> {
  constructor(title: string, details: any, size: ModalSize = ModalSize.Mini) {
    super(ViewDetailsModalComponent, { title: title, data: details });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }

}
